import Vue from 'vue'

export default Vue.extend({
  template: `
      <div style="text-align: center; display: block;">
        <a-popover :title="params.colDef['cellRendererParams'].title" trigger="hover">
          <template slot="content">{{ value }}</template>
          <a>
            <i class="fa fa-comments-o actionIcon" aria-hidden="true" style="color: #007bff" />
          </a>
        </a-popover>
      </div>
    `,
  data: function() {
    return {
      value: '',
    }
  },
  beforeMount() {
    this.value = this.params.value
  },
})
